<template>
  <div
    v-if="mobileMoreMenuIsOpen"
    class="shadow"
    style="display: block;"
    @click="toggleMobileMoreMenu"
  />
  <ul
    v-if="channels"
    class="rally-channels"
    :class="[{ open: mobileMoreMenuIsOpen }]"
  >
    <li
      class="mobile-more"
      @click="toggleMobileMoreMenu"
    >
      <i class="fal fa-ellipsis-v" />
      <span>More</span>
    </li>
    <template
      v-for="(channel, index) in visibleChannels"
      :key="channel.id"
    >
      <li
        :class="{ current: isCurrent(channel) }"
        :style="'order: ' + (index + 1) + ';'"
        tabindex="0"
        @click="navigateTo(channel.attributes.slug)"
        @keyup.enter="navigateTo(channel.attributes.slug)"
        @keyup.space="navigateTo(channel.attributes.slug)"
      >
        <i :class="'fal ' + icon(channel.attributes.icon)">  <span
          v-if="getChannelCount(channel)"
          class="badge"
        >{{ getChannelCount(channel) }}</span></i>
        {{ formatChannelName(channel.attributes.name) }}
      </li>
    </template>
    <li
      v-if="moreDesktopChannels"
      :class="['desktop-more-button', { open: desktopMoreMenuIsOpen }]"
      tabindex="0"
      @click="toggleDesktopMoreMenu"
      @keyup.enter="toggleDesktopMoreMenu"
      @keyup.space="toggleDesktopMoreMenu"
    >
      <i class="fal fa-ellipsis" />
      <span>More</span>
      <div
        v-if="desktopMoreMenuIsOpen"
        class="off-click"
        @click.stop="toggleDesktopMoreMenu"
      />
      <ul
        v-if="desktopMoreMenuIsOpen"
        class="desktop-more-menu"
      >
        <li
          v-for="(channel) in moreDesktopChannels"
          :key="channel.id"
          :class="{ current: isCurrent(channel) }"
          tabindex="0"
          @click="navigateTo(channel.attributes.slug)"
          @keyup.enter="navigateTo(channel.attributes.slug)"
          @keyup.space="navigateTo(channel.attributes.slug)"
        >
          <i :class="'fal ' + icon(channel.attributes.icon)">  <span
            v-if="getChannelCount(channel)"
            class="badge"
          >{{ getChannelCount(channel) }}</span></i>
          {{ formatChannelName(channel.attributes.name) }}
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
  import { mapState } from 'vuex';
  import { channelTypeObjectMap, getChannelSlug } from '@/common/utils';
  import { useBreakpoint } from '@/composables/useBreakpoint';

  const maxDesktopChannels = 6
  const maxTitleLength = 15

  export default {
    props: {
      rallyId: { 
        required: true,
        type: Number,
      },
    },
    emits: ['perform'],
    data: function() {
      return {
        breakpoint: useBreakpoint(),
        desktopMoreMenuIsOpen: false,
        mobileMoreMenuIsOpen: false,
      }
    },
    computed: {
      ...mapState('activities', ['channelCountsByRallyId']),
      channels() {
        const currentChannels = this.$store.getters['navigation/currentChannels']

        if ( ! currentChannels ) {
          return
        }

        return currentChannels.filter(function(channel) {
          return (
            channel.attributes.type !== "RallySettings" &&
            channel.attributes.type !== "Analytics" &&
            channel.attributes.state !== "off"
          );
        });
      },
      moreDesktopChannels() {
        if (this.breakpoint.isDesktop && this.channels.length > maxDesktopChannels + 1) {
          return this.channels.slice(maxDesktopChannels)
        }

        return false
      },
      visibleChannels() {
        if (this.breakpoint.isDesktop && this.channels.length > maxDesktopChannels + 1) {
          return this.channels.slice(0, maxDesktopChannels)
        }

        return this.channels
      },
    },
    methods: {
      formatChannelName(name){
        if ( name && name.length > maxTitleLength ){
          return name.substring(0, maxTitleLength - 2) + '...'
        } else{
          return name
        }
      },
      getChannelCount(channel){
        if (this.channelCountsByRallyId[this.rallyId] === undefined) {
          return ''
        }

        const badgeCountName = channelTypeObjectMap()[channel.attributes.type]?.badgeCountName

        if ( badgeCountName ) {
          return this.channelCountsByRallyId[this.rallyId][badgeCountName]
        }

        return ''
      },
      icon(iconClass) {
        return iconClass ? iconClass : 'fa-square'
      },
      isCurrent(channel) {
        return channel?.id == this.$store.getters['navigation/currentChannel']?.id
      },
      navigateTo(slug) {
        this.mobileMoreMenuIsOpen = false
        const thePath = `/${this.rallyId}/${slug}`
        this.$router.push(thePath)
        this.$emit('perform', 'clearParentContainers')
        window.scrollTo(0, 0)
      },
      toggleDesktopMoreMenu() {
        this.desktopMoreMenuIsOpen = !this.desktopMoreMenuIsOpen
      },
      toggleMobileMoreMenu() {
        this.mobileMoreMenuIsOpen = !this.mobileMoreMenuIsOpen
      },
    }
  }
</script>
